import script from "./UserMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./UserMenu.vue?vue&type=script&setup=true&lang=js"

import "./UserMenu.vue?vue&type=style&index=0&id=0618e2e1&lang=scss"

const __exports__ = script;

export default __exports__